export default "__VITE_ASSET__96bb1eaa__"